<div class="c-field-value--image-preview">
  <a [routerLink]="['/app/offers', row.id]">
    <img [src]="url || 'assets/img/offer-preview-empty-1.svg'" alt="preview" />
  </a>
</div>
